import DonutChartFilterable from './donut-chart-filterable';
export default DonutChartFilterable;
